import { PlayerErrors } from '../types/instance';

export const PlayerErrorCodeMap: Record<PlayerErrors, string | number> = {
    [PlayerErrors.loadingPlayerError]: 'LOADING_PLAYER_ERROR',
};

export const PlayerErrorMessageMap: Record<PlayerErrors, string> = {
    [PlayerErrors.loadingPlayerError]: 'Loading Ya player failed',
};

export enum PlayerLoadingErrorCategory {
    Network = 'NETWORK_TIMEOUT',
}
